import { render, staticRenderFns } from "./ServiceForm.vue?vue&type=template&id=10eb7813&scoped=true"
import script from "./ServiceForm.vue?vue&type=script&lang=js"
export * from "./ServiceForm.vue?vue&type=script&lang=js"
import style0 from "./ServiceForm.vue?vue&type=style&index=0&id=10eb7813&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10eb7813",
  null
  
)

export default component.exports